<template>
  <div class='ei-goods-item'>
    <img :data-src="imgUrl" class="image" alt="" v-if="lazy">
    <img :src="imgUrl" class="image" alt="" v-else>
    <div style="padding: 14px;">
      <div class="title">
        <span :title="title">{{ title }}</span>
      </div>
      <div class="bottom">
        <span class="other" :title="other">{{ other }}</span>
        <span class="button1">查看详情</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EiGoodsItem',
  props: {
    lazy: {
      type: Boolean,
      default: false,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '作品名称',
    },
    other: {
      type: String,
      default: '作品简介',
    },
  }
}
</script>

<style scoped lang="scss">
.ei-goods-item {
  display: inline-block;
  position: relative;
  width: 300px;
  height: 400px;
  margin-bottom: 20px;
  border: 1px solid #A37D4C;
  transition: all 0.4s ease-out 0s;
  cursor: pointer;

  .image {
    display: block;
    width: 180px;
    height: 270px;
    margin: 20px auto;
    transition: 0.5s ease;
    cursor: pointer;
  }

  .title {
    width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
    text-align: center;
    margin-left: -20px;
  }

  :before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    border-top: 1px solid rgb(255, 18, 49);
    border-left: 1px solid rgb(255, 18, 49);
    width: 0;
    height: 0;
    transition: all 0.4s ease-out 0s;
    visibility: hidden;
    box-sizing: border-box;
  }

  :after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    border-right: 1px solid rgb(255, 18, 49);
    border-bottom: 1px solid rgb(255, 18, 49);
    width: 0;
    height: 0;
    transition: all 0.4s ease-out 0s;
    visibility: hidden;
    box-sizing: border-box;
  }

  .other {
    margin-left: 12px;
    font-size: 15px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

/*  .button {
    padding: 0px;
    float: right;
  }*/

  &.first {
    margin-left: 0;
  }

  &:hover {
    box-shadow: 1px 15px 20px 0 rgba(0, 0, 0, .2);

    .image {
      transform: translateZ(0) scale(1.1);
      transition: 0.5s ease;
    }

    :before {
      width: 100%;
      height: 100%;
      visibility: visible;
    }

    :after {
      width: 100%;
      height: 100%;
      visibility: visible;
    }
  }

}
.button1{
  margin-left: 118px;
}

</style>
